import { Button, Table, Space, notification } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { DELETE, POST } from "../../utils/apicalls";
import LoadingAnimation from "../../componets/loader/loader";

function ContactMessages() {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [meta, setMeta] = useState<any>({});
    const [data, setData] = useState<any>([]);

    const [isLoading, setIsLoading] = useState(false);

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "customerName", dataIndex: "customerName" },
        {
            title: "Created At",
            dataIndex: "createdAt",
            render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
        },
        { title: "customerEmail", dataIndex: "customerEmail" },
        { title: "mobile_number", dataIndex: "mobile_number" },
        { title: "customerSubject", dataIndex: "customerSubject" },
        { title: "message", dataIndex: "message" },
        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>
                        Delete
                    </Button>
                </Space>
            ),
        },
    ];

    const fetchContactus = async (currentPage: number, currentPageSize: number) => {
        try {
            setIsLoading(true);
            const obj = {
                query: "query",
                page: currentPage,
                take: currentPageSize,
            };

            const url = API.LIST_CONTACT_MESSAGE;
            const response: any = await POST(url, obj);

            setData(response?.data);
            setMeta(response?.meta);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_REVIEWS}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: "Review deleted successfully!" });
                fetchContactus(page, pageSize);
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };


    useEffect(() => {
        fetchContactus(page, pageSize);
    }, [page, pageSize]);

    return (
        <div className="container mt-4">
            {isLoading ? (
                <LoadingAnimation />
            ) : (
                <>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12">
                            <h2 className="text-center mb-4">Customer Reviews</h2>


                            <div>
                                <div className="table-responsive" style={{ overflowX: "auto" }}>
                                    <Table
                                        columns={columns}
                                        dataSource={data}
                                        loading={isLoading}
                                        pagination={{
                                            current: page,
                                            pageSize: pageSize,
                                            total: meta?.total,
                                            showSizeChanger: true,
                                            onChange: (currentPage: number, currentSize: number) => {
                                                setPage(currentPage);
                                                setPageSize(currentSize);
                                            },
                                        }}
                                        rowKey={(record: any) => record.id || record.reviwerName}
                                        scroll={{ x: "max-content" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default ContactMessages
